module.exports = __webpack_public_path__ + "img/de.dad155d8.svg";